// Copyright 2023 Huawei Cloud Computing Technology Co., Ltd.
//
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
//     http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.

import {OpusDecoder, OpusEncoder} from "../3rd/opus/opus";

const encoder = new OpusEncoder(48000, 1, 2049, 20);

self.addEventListener('message', evt => {
    const message = evt.data;
    switch (message.type) {
    case 'encode': {
        let opusData = encoder.encode_float(message.data);
        self.postMessage({
            type: 'encodeResult',
            data: opusData
        }, []);
        break;
    };
    default:
        // do nothing
    }
});

export default function () {}